export const strings = {
  // Navigation
  progress: { en: 'Progress', cn: '进步' },
  schedule: { en: 'Schedule', cn: '课程安排' },
  billing: { en: 'Billing', cn: '账单' },
  goals: { en: 'Goals', cn: '目标' },
  messages: { en: 'Messages', cn: '消息' },
  classes: { en: 'My Classes', cn: '我的课程' },
  myProgress: { en: 'My Progress', cn: '我的进步' },
  myGoals: { en: 'My Goals', cn: '我的目标' },
  taAttendance: { en: 'TA Attendance', cn: '助教考勤' },
  roster: { en: 'Roster', cn: '名单' },
  noTaClassesAssigned: { en: 'No TA classes assigned yet.', cn: '暂未分配助教课程。' },
  noTaAttendanceSessions: { en: 'No sessions available for this class yet.', cn: '该课程暂时没有可记录的课次。' },
  noTaRoster: { en: 'No students are rostered for this class yet.', cn: '该课程暂时没有学生名单。' },
  attendanceSaved: { en: 'Attendance saved.', cn: '考勤已保存。' },
  attendanceSaveFailed: { en: 'Could not save attendance right now.', cn: '暂时无法保存考勤。' },
  taLandingSubtitle: { en: 'Open the TA attendance portal', cn: '进入助教考勤入口' },
  openAttendance: { en: 'Open Attendance', cn: '进入考勤' },
  taSchedule: { en: 'My Schedule', cn: '我的课表' },
  noUpcomingSessions: { en: 'No upcoming sessions scheduled.', cn: '暂无即将到来的课程。' },
  today: { en: 'Today', cn: '今天' },
  students: { en: 'students', cn: '名学生' },

  // Auth
  authenticating: { en: 'Authenticating...', cn: '正在验证...' },
  invalidToken: { en: 'Invalid or expired link. Please request a new one from your teacher.', cn: '链接无效或已过期。请联系老师获取新链接。' },
  authError: { en: 'Authentication failed. Please try again.', cn: '验证失败，请重试。' },
  // #366 typed 429 (`rate_limited`): calm, temporary, never "invalid link".
  rateLimited: { en: 'Too many requests right now. Please wait a moment and try again.', cn: '请求过于频繁，请稍等片刻后再试。' },
  rateLimitedTitle: { en: 'Please wait a moment', cn: '请稍候' },
  signOut: { en: 'Sign Out', cn: '退出登录' },
  requestNewLink: { en: 'Request New Link', cn: '请求新链接' },

  // Header
  parentPortal: { en: 'Matt SD', cn: 'Matt SD' },
  studentPortal: { en: 'Matt SD', cn: 'Matt SD' },
  taPortal: { en: 'Matt SD TA', cn: 'Matt SD 助教' },
  switchChild: { en: 'Switch Child', cn: '切换孩子' },
  language: { en: '中文', cn: 'EN' },
  lastUpdated: { en: 'Last updated', cn: '上次更新' },
  lastUpdatedUnknown: { en: 'unavailable', cn: '暂不可用' },
  updatedJustNow: { en: 'just now', cn: '刚刚' },
  dataMayBeDelayed: { en: 'Data may be delayed', cn: '数据可能有延迟' },

  // Progress page
  averageScores: { en: 'Average Scores', cn: '平均分数' },
  attendanceRate: { en: 'Attendance Rate', cn: '出勤率' },
  feedbackSessions: { en: 'Feedback Sessions', cn: '反馈课次' },
  latestFeedbackDate: { en: 'Latest Feedback', cn: '最近反馈' },
  progressTrend: { en: 'Recent Trend', cn: '近期趋势' },
  labelColon: { en: ': ', cn: '：' },
  learningObjective: { en: 'Learning objective', cn: '本节目标' },
  whatWeDid: { en: 'What we did', cn: '课堂回顾' },
  participation: { en: 'Participation', cn: '课堂参与' },
  motivation: { en: 'Motivation', cn: '学习积极性' },
  homework: { en: 'Homework', cn: '作业' },
  metObjective: { en: 'Met Objective', cn: '达到目标' },
  helpfulness: { en: 'Helpfulness', cn: '帮助程度' },
  reliability: { en: 'Reliability', cn: '可靠程度' },
  mentoring: { en: 'Mentoring', cn: '带教能力' },
  // Score descriptors (per-category, per-level)
  participation_5: { en: 'Actively contributes', cn: '积极参与' },
  participation_4: { en: 'Frequently participates', cn: '经常参与' },
  participation_3: { en: 'Participates when prompted', cn: '在引导下参与' },
  participation_2: { en: 'Rarely participates', cn: '较少参与' },
  participation_1: { en: 'Needs encouragement', cn: '需要更多鼓励' },
  motivation_5: { en: 'Highly motivated', cn: '学习动力很强' },
  motivation_4: { en: 'Good motivation', cn: '动力较好' },
  motivation_3: { en: 'Generally motivated', cn: '基本有动力' },
  motivation_2: { en: 'Inconsistent motivation', cn: '动力不稳定' },
  motivation_1: { en: 'Needs encouragement', cn: '需要鼓励' },
  homework_5: { en: 'Consistent and on time', cn: '按时完成' },
  homework_4: { en: 'Mostly complete', cn: '基本完成' },
  homework_3: { en: 'Needs more consistency', cn: '需要更加一致' },
  homework_2: { en: 'Often incomplete', cn: '经常未完成' },
  homework_1: { en: 'Needs improvement', cn: '需要改进' },
  met_objective_5: { en: 'Exceeded expectations', cn: '超出预期' },
  met_objective_4: { en: 'Met expectations', cn: '达到预期' },
  met_objective_3: { en: 'Developing', cn: '发展中' },
  met_objective_2: { en: 'Below expectations', cn: '低于预期' },
  met_objective_1: { en: 'Not yet meeting objective', cn: '尚未达到目标' },

  recentFeedback: { en: 'Recent Feedback', cn: '最近反馈' },
  sessionDate: { en: 'Session', cn: '课时' },
  noFeedback: { en: 'Feedback in progress', cn: '反馈准备中' },
  olderFeedbackNotLoaded: { en: 'Older feedback may not be loaded.', cn: '更早的反馈可能尚未加载。' },
  teacherNotes: { en: 'Teacher Notes', cn: '老师评语' },

  // Schedule page
  upcomingSessions: { en: 'Upcoming Sessions', cn: '即将到来的课程' },
  pastSessions: { en: 'Past Sessions', cn: '过去的课程' },
  taRole: { en: 'TA', cn: '助教' },
  noUpcoming: { en: 'No upcoming sessions scheduled.', cn: '暂无即将到来的课程。' },
  present: { en: 'Present', cn: '出席' },
  absent: { en: 'Absent', cn: '缺席' },
  makeup: { en: 'Makeup', cn: '补课' },
  noClasses: { en: 'No enrolled classes found.', cn: '未找到已注册的课程。' },
  // Last link in the class-label fallback chain (alias → time → this). The
  // internal class name is an operator code and never renders to a parent.
  classLabelFallback: { en: 'Class', cn: '课程' },

  // Billing page
  billingSummary: { en: 'Billing Summary', cn: '账单概览' },
  currentBalance: { en: 'Current Balance', cn: '当前余额' },
  semesterBreakdown: { en: 'Semester Breakdown', cn: '各学期明细' },
  showEarlierSemesters: { en: 'Show earlier semesters', cn: '显示更早学期' },
  hideEarlierSemesters: { en: 'Hide earlier semesters', cn: '收起更早学期' },
  showEarlierFeedback: { en: 'Show earlier feedback', cn: '显示更早反馈' },
  hideEarlierFeedback: { en: 'Hide earlier feedback', cn: '收起更早反馈' },
  showEarlierHomework: { en: 'Show earlier homework', cn: '显示更早作业' },
  hideEarlierHomework: { en: 'Hide earlier homework', cn: '收起更早作业' },
  familyOwes: { en: 'Amount You Owe', cn: '您需支付' },
  companyOwes: { en: 'Refund / Rollover Due to You', cn: '应退还或结转给您' },
  availableCredit: { en: 'Available Credit', cn: '可用余额' },
  creditDeficit: { en: 'Credit Deficit', cn: '余额不足' },
  totalPurchased: { en: 'Credits Purchased', cn: '已购买额度' },
  totalConsumed: { en: 'Credits Used', cn: '已使用额度' },
  semesterConsumed: { en: 'Used This Semester', cn: '本学期已使用' },
  grossContract: { en: 'Gross Contract', cn: '合同原价' },
  netContract: { en: 'Net Contract', cn: '折后金额' },
  cashReceived: { en: 'Cash Paid', cn: '已付现金' },
  cashRefunded: { en: 'Cash Refunded', cn: '已退现金' },
  rolloverIn: { en: 'Rollover In', cn: '结余转入' },
  rolloverOut: { en: 'Rollover Out', cn: '结余转出' },
  rolloverHistory: { en: 'Rollover History', cn: '结余转移记录' },
  rolloverDirectionIn: { en: 'Rollover In', cn: '结余转入' },
  rolloverDirectionOut: { en: 'Rollover Out', cn: '结余转出' },
  settlementDue: { en: 'Ready to Refund / Rollover', cn: '可退还或结转' },
  totalCharged: { en: 'Total Charged', cn: '总费用' },
  totalPaid: { en: 'Total Paid', cn: '已付金额' },
  discounts: { en: 'Discounts', cn: '折扣' },
  refunds: { en: 'Refunds', cn: '退款' },
  remaining: { en: 'Remaining', cn: '剩余' },
  paymentHistory: { en: 'Payment History', cn: '付款记录' },
  noPayments: { en: 'No payment records found.', cn: '未找到付款记录。' },
  date: { en: 'Date', cn: '日期' },
  amount: { en: 'Amount', cn: '金额' },
  method: { en: 'Method', cn: '方式' },
  note: { en: 'Note', cn: '备注' },

  // Goals page
  activeGoals: { en: 'Active Goals', cn: '当前目标' },
  completedGoals: { en: 'Completed Goals', cn: '已完成目标' },
  noGoals: { en: 'No goals set yet.', cn: '暂未设定目标。' },
  suggestGoal: { en: 'Suggest a Goal', cn: '建议一个目标' },
  setPersonalGoals: { en: 'Set personal goals', cn: '设定个人目标' },
  goalPlaceholder: { en: 'What goal would you suggest for your child?', cn: '您想为孩子建议什么目标？' },
  studentGoalPlaceholder: { en: 'Set your personal goals for the semester', cn: '设定你这学期的个人目标' },
  goalType: { en: 'Goal Type', cn: '目标类型' },
  submit: { en: 'Submit', cn: '提交' },
  submitting: { en: 'Submitting...', cn: '提交中...' },
  setBy: { en: 'Set by', cn: '设定者' },
  parent: { en: 'Parent', cn: '家长' },
  teacher: { en: 'Teacher', cn: '老师' },
  student: { en: 'Student', cn: '学生' },
  speaking: { en: 'Speaking', cn: '口语表达' },
  thinking: { en: 'Thinking', cn: '思维能力' },
  confidence: { en: 'Confidence', cn: '自信心' },
  fluency: { en: 'Fluency', cn: '流利度' },
  tournament: { en: 'Tournament', cn: '比赛' },
  organization: { en: 'Organization', cn: '组织能力' },
  independence: { en: 'Independence', cn: '自主学习' },
  teamwork: { en: 'Teamwork', cn: '团队合作' },
  other: { en: 'Other', cn: '其他' },
  active: { en: 'Active', cn: '进行中' },
  completed: { en: 'Completed', cn: '已完成' },
  onHold: { en: 'On Hold', cn: '暂停' },
  progressNotes: { en: 'Progress Notes', cn: '进展记录' },

  // Messages page
  recentMessages: { en: 'Recent Messages', cn: '最近消息' },
  sentMessages: { en: 'Messages from Teacher', cn: '老师发送的消息' },
  noMessages: { en: 'No messages yet.', cn: '暂无消息。' },
  sentOn: { en: 'Sent', cn: '发送时间' },

  // Homework page
  assignments: { en: 'Assignments', cn: '作业' },
  taFeedback: { en: 'TA Feedback', cn: '助教反馈' },
  myTaClasses: { en: 'My TA Classes', cn: '我的助教课程' },
  allClasses: { en: 'All Classes', cn: '全部课程' },
  noTaFeedbackSessions: { en: 'No TA sessions available yet.', cn: '暂无可填写反馈的助教课次。' },
  sessionFeedback: { en: 'Session Feedback', cn: '课次反馈' },
  feedbackNotes: { en: 'Session Notes', cn: '课次备注' },
  feedbackNotesPlaceholder: { en: 'How did the session go? What should the teacher know?', cn: '这节课进行得怎么样？有什么需要老师了解的情况？' },
  assignedTasks: { en: 'Assigned Tasks', cn: '分配任务' },
  assignedTasksPlaceholder: { en: 'What did you cover or help with during this session?', cn: '这节课你主要负责了哪些任务或支持？' },
  saveFeedback: { en: 'Save Feedback', cn: '保存反馈' },
  saving: { en: 'Saving...', cn: '保存中...' },
  feedbackSaved: { en: 'Feedback saved.', cn: '反馈已保存。' },
  feedbackSaveFailed: { en: 'Could not save feedback right now.', cn: '暂时无法保存反馈。' },
  feedbackRequiresInput: { en: 'Add at least one score or note before saving.', cn: '请至少填写一个评分或备注后再保存。' },
  saved: { en: 'Saved', cn: '已保存' },
  notStarted: { en: 'Not started', cn: '未开始' },
  submitHomework: { en: 'Submit Homework', cn: '提交作业' },
  uploadFile: { en: 'Upload File', cn: '上传文件' },
  submitted: { en: 'Submitted', cn: '已提交' },
  notSubmitted: { en: 'Not Submitted', cn: '未提交' },
  assignmentOpen: { en: 'Open', cn: '待完成' },
  checkedInClass: { en: 'Checked in class', cn: '老师已检查' },
  homeworkNotRecorded: { en: 'Not recorded', cn: '未记录' },
  homeworkUnknown: { en: 'Feedback unavailable', cn: '反馈暂不可用' },
  graded: { en: 'Graded', cn: '已评分' },
  reviewed: { en: 'Reviewed', cn: '已审阅' },
  returned: { en: 'Returned', cn: '已退回' },
  lateSubmission: { en: 'Late', cn: '迟交' },
  dueDate: { en: 'Due', cn: '截止日期' },
  grade: { en: 'Grade', cn: '成绩' },
  noAssignments: { en: 'No assignments yet.', cn: '暂无作业。' },
  uploadSuccess: { en: 'Uploaded successfully!', cn: '上传成功！' },
  uploading: { en: 'Uploading...', cn: '上传中...' },

  // Single-page section headers
  upcomingClasses: { en: 'Upcoming Classes', cn: '即将上课' },
  fullSchedule: { en: 'Full Schedule', cn: '完整课程表' },
  showHistory: { en: 'Show History', cn: '显示历史' },
  hideHistory: { en: 'Hide History', cn: '隐藏历史' },
  showMore: { en: 'Show more', cn: '展开' },
  showLess: { en: 'Show less', cn: '收起' },
  charged: { en: 'Charged', cn: '费用' },
  paid: { en: 'Paid', cn: '已付' },
  noUpcomingSessions: { en: 'No upcoming sessions', cn: '暂无即将到来的课程' },
  nextClass: { en: 'Next Class', cn: '下一节课' },
  showFullSchedule: { en: 'Show Full Schedule', cn: '查看完整课程表' },
  hideFullSchedule: { en: 'Hide Schedule', cn: '收起课程表' },
  balanceDue: { en: 'Balance Due', cn: '余额' },
  paidInFull: { en: 'Paid in Full', cn: '已付清' },
  overpaid: { en: 'Overpaid', cn: '超付' },
  showPayments: { en: 'Show Payment History', cn: '查看付款记录' },
  hidePayments: { en: 'Hide', cn: '收起' },
  assignmentDetails: { en: 'Details', cn: '详情' },
  viewDetails: { en: 'View details', cn: '查看详情' },
  hideDetails: { en: 'Hide details', cn: '收起详情' },
  description: { en: 'Description', cn: '描述' },
  submittedOn: { en: 'Submitted', cn: '提交时间' },

  // Welcome / Header
  welcomeBack: { en: 'Welcome back,', cn: '欢迎回来，' },
  teacherUpdate: { en: "Teacher's Update", cn: '老师评语' },

  // General
  loading: { en: 'Loading...', cn: '加载中...' },
  error: { en: 'Something went wrong. Please try again.', cn: '出了点问题，请重试。' },
  retry: { en: 'Retry', cn: '重试' },
  noData: { en: 'No data available.', cn: '暂无数据。' },
  dataUnavailableTitle: { en: 'Data unavailable', cn: '数据暂时不可用' },
  dataUnavailableBody: { en: 'This section could not be loaded right now.', cn: '该部分当前无法加载。' },
}
